import { Selector } from '@ngxs/store';

import { UnitTemplateFilters, UnitTemplatesWithFilters } from '../../models';
import { ProjectUnitTemplateState, UnitSelectionStateModel } from './unit-template.state';

export class UnitTemplateSelectors {
  @Selector([ProjectUnitTemplateState])
  static getFilters(state: UnitSelectionStateModel): UnitTemplateFilters {
    return state.filters;
  }

  @Selector([ProjectUnitTemplateState])
  static getUnitsTemplateWithFilters(state: UnitSelectionStateModel) {
    return state.unitTemplateWithFilters;
  }

  @Selector([ProjectUnitTemplateState])
  static getUnitsTemplateGroups(state: UnitSelectionStateModel) {
    return state.groups;
  }

  @Selector([ProjectUnitTemplateState])
  static getSelectedGroups(state: UnitSelectionStateModel) {
    return state.selectedGroup;
  }

  @Selector([UnitTemplateSelectors.getUnitsTemplateWithFilters])
  static getUnitsTemplate(state: UnitTemplatesWithFilters) {
    const templates = state ? state.list : [];
    for (const template of templates) {
      if (template.childUnitId != null) {
        template.childUnit = templates.find(t => t.uuid === template.childUnitId);
      }
    }
    return templates.filter(t => !t.isExternalUnit);
  }

  @Selector([UnitTemplateSelectors.getUnitsTemplateWithFilters])
  static getUnitsTemplateFilters(state: UnitTemplatesWithFilters) {
    return state ? state.filters : [];
  }
}
